import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached follow_invites data
export function useFollowInvitesSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/follow_invites"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
